import { renderIsomorphicComponent, renderBreakingNews, renderComponent } from "@quintype/framework/client/start";
import { pickComponent } from "../isomorphic/pick-component";
import BreakingNews from "../isomorphic/components/rows/breaking-news";
import Footer from "../../app/isomorphic/components/rows/footer";
import Header from "../../app/isomorphic/components/rows/header";
import { DfpAd } from "../../app/isomorphic/components/atoms/dfp-ad";

export function preRenderApplication(store) {
  renderComponent(Header, "header", store);
  renderComponent(Footer, "footer", store);
  renderComponent(DfpAd, "header-ad", store, {
    adtype: "Large_Leaderboard",
    placement: "header",
    slotId: "top-header-ad"
  });
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  global.qtConfig = store && store.getState().qt.config;
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell
  });
  renderBreakingNews("breaking-news-container", store, BreakingNews);
}
